import React, {useEffect, useState} from "react";
import {Button, Card, Checkbox, Col, Form, Row, Space, theme} from "antd";
import {AgentNewContext} from "../../agent.new.modal";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {AgentNewStepAddressesValues} from "./agent.new.step.addresses.values";
import {useAgentNewStepCardStyles} from "../agent.new.step.card.styles";

export const AddressesStep: React.FC = () => {

    const {setStep, getValue, setValue, fields} = React.useContext(AgentNewContext);

    const t = useTranslate();
    const {token} = theme.useToken();
    const cardStyles = useAgentNewStepCardStyles();

    const [loading, setLoading] = useState<boolean>(false);

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFields(fields);
    }, [fields])

    const [shippingSameAsBilling, setShippingSameAsBilling] = useState<boolean>(false);

    const defaultValues: any = {
        billingAddress: getValue('billingAddress'),
        shippingAddress: getValue('shippingAddress'),
        addressesOptions: getValue('addressesOptions')
    }
    return <Space direction="vertical" size={[15, 15]} style={{width: "100%"}}>
        <Form
            size={"middle"}
            form={form}
            layout="vertical"
            name={"client_form"}
            initialValues={defaultValues}
            onFinish={async (values) => {
                await form.validateFields();
                setValue('billingAddress', values.billingAddress)
                setValue('shippingAddress', shippingSameAsBilling ? values.billingAddress : values.shippingAddress)
                setValue('addressesOptions', values.addressesOptions)
                setStep(5)
            }}
        >
            <Row gutter={[16, 16]} align="top">
                <Col xs={24} md={12}>
                    <Card
                        size="small"
                        title={t("BILLING_ADDRESS", {defaultValue: "Billing address"})}
                        style={{width: "100%"}}
                        styles={cardStyles}
                    >
                        <AgentNewStepAddressesValues
                            name="billingAddress"
                            loading={loading}
                            form={form}
                        />
                    </Card>
                </Col>
                <Col xs={24} md={12}>
                    <Card
                        size="small"
                        title={t("SHIPPING_ADDRESS", {defaultValue: "Shipping address"})}
                        extra={(
                            <Checkbox
                                checked={shippingSameAsBilling}
                                style={{color: token.colorTextSecondary}}
                                onChange={(event) => setShippingSameAsBilling(event.target.checked)}
                            >
                                {t("ADD_SAME_SHIPPING_ADDRESS")}
                            </Checkbox>
                        )}
                        style={{width: "100%"}}
                        styles={cardStyles}
                    >
                        <AgentNewStepAddressesValues
                            name="shippingAddress"
                            loading={loading}
                            form={form}
                            disabled={shippingSameAsBilling}
                        />
                    </Card>
                </Col>
                <Col xs={24} md={12}>
                    <Card
                        size="small"
                        title={t("OPTIONS", {defaultValue: "Options"})}
                        style={{width: "100%"}}
                        styles={cardStyles}
                    >
                        <Form.Item
                            name={["addressesOptions", "allowedAddressManagement"]}
                            label={t("ADDRESSES.ALLOW_MANAGEMENT")}
                            valuePropName="checked"
                        >
                            <Checkbox />
                        </Form.Item>
                    </Card>
                </Col>
            </Row>
            <Row gutter={[30, 0]} align="top" style={{marginTop: 16}}>
                <Col span={24}>
                    <Space direction={"horizontal"} size={[10, 10]}>
                        <Button type={"default"} onClick={() => setStep(3)}>Back</Button>
                        <Button type={"primary"} onClick={() => form.submit()}>Next</Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    </Space>
}
